// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 308 ? "quiz" : chunkId) + "." + {"308":"24f675ed","529":"41aaf820","623":"6f98cf49"}[chunkId] + ".js";
};